export class ReportHeaderData {
  constructor(public name: string, public value: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/ReportHeaderData.ts